// Pure sidebar item visibility rule (extracted from AppShell so it is unit-testable). No behaviour change for existing items.
// platformOnly: platform admin only. allowRoles: those roles plus the platform admin.
export function isSidebarItemVisible(item, { userRole, featureFlags = {}, hasPermission, platformAdmin = false }) {
  if (item.platformOnly && !platformAdmin) return false;
  if (item.allowRoles && !platformAdmin && !item.allowRoles.includes(userRole)) return false;
  if (item.requireRole && userRole !== item.requireRole) return false;
  if (item.featureFlag && !featureFlags[item.featureFlag]) return false;
  if (item.visibleWhen && !item.visibleWhen(hasPermission)) return false;
  return (item.permissions || []).length === 0 || item.permissions.some(p => hasPermission(p));
}
